const modulesQuestions = {
  1 : {
    id: 1,
    title: 'Organization',
    question2:
      'What day(s)/time(s) will clean-up/organization take place each week?',
    question3: 'Where will the clean-up/organization take place?',
    question4: 'What will happen during the clean-up/organization?',
    question5:
      'How will you remember to clean up your materials and complete the organization checklist?',
    question6: (userName) => `When should ${userName} check your organization checklist?`
  },
  2:{
    id: 2,
    title: 'Homework Recording',
    question1:
      'How often will you check to make sure you recorded all homework/assignments in your calendar?',
    question2: 'What day(s)/time(s) will this take place each week?',
    question3: 'Where will this take place?',
    question4:
      'What will happen during the homework recording (i.e., what activities will be completed)?',
    question5:
      'How will you remember to record your homework/assignments in your calendar?',
    question6:(userName) =>  `When should ${userName} check your calendar for homework recording and complete the homework recording checklist?`
  },
  3:{
    id: 3,
    title: 'Homework Completion',
    question1:
      'How often will you work on completing homework each week?',
    question2:
      'What day(s)/time(s) will homework completion take place each week?',
    question3: 'Where will homework completion take place?',
    question4: 'What will happen during the homework completion?',
    question5: 'How will you remember to complete your homework?',
    question6: (userName) => `When should ${userName} check your homework completion?`
  },
  4:{
    id: 4,
    title: 'Time Management',
    question1:
      'How often will you practice time management/planning each week?',
    question2:
      'What day(s)/time(s) will time management/planning take place each week?',
    question3: 'Where will the time management/planning take place?',
    question4: 'What will happen during the time management/planning?',
    question5:
      'How will you remember to practice time management/planning?',
    question6: (userName) => `When should ${userName} check your time management/planning skills checklist?`
  },
  5:{
    id: 5,
    title: 'Self Management',
    question1:
      'How often will you complete the self-management checklist each week?',
    question2: 'What day(s)/time(s) will your self-management take place each week?',
    question3: 'Where will it take place?',
    question4:
      'What will happen (i.e., what activities will be completed)?',
    question5:
      'How will you remember to review your self-management checklist?'
  }
}

export default { 
  modulesQuestions
}